import { useEffect, useMemo } from 'react';
import { getRoute } from '../routes';
import { removeRedirectUrl, setRedirectUrl } from './authenticationStore';
import { parseMrnIntoRoute } from './mrn';

export const useSaveRedirection = (searchParams: Record<string, string>): void => {
  const redirectUrl = useMemo(() => {
    const path = searchParams.to ?? getRoute('home', {});
    if (searchParams.mrn != null) {
      const { to: redirectUrlForMrn } = parseMrnIntoRoute(searchParams.mrn);
      return redirectUrlForMrn;
    }

    if (
      path.startsWith(getRoute('login', {})) ||
      path.startsWith(getRoute('logout', {})) ||
      path.startsWith(getRoute('signup', {})) ||
      path === getRoute('start', {})
    ) {
      // Avoid redirect loops.
      return getRoute('home', {});
    }

    return path;
  }, [searchParams]);

  useEffect(() => {
    if (redirectUrl === getRoute('home', {})) {
      // Home is default route so nothing to do, and let's clear any stale redirect
      void removeRedirectUrl();
      return;
    }
    void setRedirectUrl(redirectUrl);
  }, [redirectUrl]);
};
